import ReactGA from "react-ga4";

export const initGA = () => {
  const consent = localStorage.getItem("cookieConsent");
  if (consent === "all") {
    ReactGA.initialize("G-WXZQ92TM53");
  }
};

export const sendPageview = (path) => {
  const consent = localStorage.getItem("cookieConsent");
  if (consent === "all") {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

export const trackUTMs = () => {
  const url = new URL(window.location.href);
  const source = url.searchParams.get("utm_source");
  const campaign = url.searchParams.get("utm_campaign");

  if (source) sessionStorage.setItem("utm_source", source);
  if (campaign) sessionStorage.setItem("utm_campaign", campaign);
};
